module.exports = __webpack_public_path__ + "img/0-02-0a-798c58b803b3972df16022a2c864055ba64f5146a722909765327b1ff1cd52ca_70dfe655.b613a626.jpg";